import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChange,
} from "@angular/core";
import { TransportHistoryService } from "../../../_services/transport-history.service";

@Component({
  selector: "app-history-table",
  templateUrl: "./history-table.component.html",
  styleUrls: ["./history-table.component.css"],
})
export class HistoryTableComponent implements OnChanges {
  @Input() departure_id: number;
  @Input() arrival_id: number;
  @Input() client_id: number;
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();

  private changing: boolean = false;
  private shown: boolean = true;

  private transports: any[] = [];

  constructor(private service: TransportHistoryService) {}

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    // console.log('CHANGED')
    this.getHistory();
    this.changing = true;
  }

  getHistory() {
    this.service
      .getHistory(this.departure_id, this.arrival_id, this.client_id)
      .subscribe((response) => {
        this.transports = response;
      });
  }

  chooseTransport(transport) {
    this.selected.emit(transport);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/transport-history/history-table/history-table.component.ts